import React, { Component } from 'react';
import { Container, Row, Col, Card, Carousel, CarouselItem, CarouselIndicators } from 'reactstrap';

export class NewsCarousel extends Component {
  static displayName = NewsCarousel.name;

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      animating: false
    };
  }

  next = () => {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === this.newsItems.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous = () => {
    if (this.state.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.newsItems.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex = (newIndex) => {
    if (this.state.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  newsItems = [
    {
      title: "Devocionales",
      content: "Ahora Encuentranos en Spotify y Apple Podcast.",
      date: "Siempre disponibles",
      image: "/images/news/Devocional.png",
      alt: "Devocionales - Spotify y Apple Podcast"
    },
    {
      title: "Escuela Bíblica de Vacaciones",
      content: "Descubramos la GRANDEZA de Dios en las COSAS pequeñas.",
      date: "6-10 de Octubre, 2025",
      image: "/images/news/Exaltados.jpg",
      alt: "Exaltados"
    },
    {
      title: "Renovadas",
      content: "Un tiempo especial para las mujeres de la iglesia. Conferencias, talleres y momentos de comunión.",
      date: "24-26 Octubre, 2025",
      image: "/images/news/Renovadas.jpg",
      alt: "Renovadas - Congreso de Mujeres"
    },
    {
      title: "Acierta",
      content: "Campamento diseñado para fortalecer la fe y la hermandad entre los hombres de la iglesia.",
      date: "7-9 Noviembre, 2025",
      image: "/images/news/Acierta.jpg",
      alt: "Acierta - Campamento de Varones"
    }
    
  ];

  render() {
    const { activeIndex } = this.state;

    const slides = this.newsItems.map((item, index) => {
      return (
        <CarouselItem
          onExiting={() => this.setState({ animating: true })}
          onExited={() => this.setState({ animating: false })}
          key={index}
        >
          <Card className="news-carousel h-100">
            <div className="row g-0 h-100">
              <div className="col-md-6">
                <img 
                  src={item.image} 
                  alt={item.alt}
                  className="img-fluid h-100"
                  style={{ 
                    objectFit: 'cover',
                    width: '100%',
                    minHeight: '300px'
                  }}
                />
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <div className="card-body text-center p-4">
                  <h4 className="card-title mb-3" style={{ color: 'var(--dark-blue)' }}>
                    {item.title}
                  </h4>
                  <p className="card-text lead mb-3">
                    {item.content}
                  </p>
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fas fa-calendar-alt me-2" style={{ color: 'var(--primary-blue)' }}></i>
                    <small className="text-muted fw-bold">
                      {item.date}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </CarouselItem>
      );
    });

    return (
      <section className="section news-carousel-section" style={{ backgroundColor: 'var(--light-cream)' }}>
        <Container>
          <h2 className="section-title">Noticias y Anuncios</h2>
          <Row>
            <Col lg="10" className="mx-auto">
              <Carousel
                activeIndex={activeIndex}
                next={this.next}
                previous={this.previous}
                interval={false}
              >
                {slides}
                <CarouselIndicators 
                  items={this.newsItems} 
                  activeIndex={activeIndex} 
                  onClickHandler={this.goToIndex} 
                />
              </Carousel>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
